import { toast } from "sonner";

export type ProductImagePreparationResult = {
  usedFallback?: boolean;
  processing?: "background_removed" | "cropped" | "unchanged";
};

export function notifyProductImagePreparation(
  result: ProductImagePreparationResult
): void {
  if (result.usedFallback || result.processing === "unchanged") {
    toast.message(
      "The original image was kept because it could not be safely prepared."
    );
    return;
  }
  if (result.processing === "background_removed") {
    toast.success("Background removed and product image cropped.");
    return;
  }
  toast.message(
    "Background could not be removed safely; excess border was cropped instead."
  );
}
